/**
 * Real-time Form Field Validation
 * Automatically attaches validation to all inputs inside .o-form-1__input containers.
 */

document.addEventListener('DOMContentLoaded', function() {
    // 1. Find all forms that contain our specific input class
    const forms = document.querySelectorAll('form');
    
    forms.forEach(form => {
        // If the form doesn't have any .o-form-1__input, skip it.
        if (!form.querySelector('.o-form-1__input')) return;
        
        // Disable default browser validation popups
        form.setAttribute('novalidate', 'true');
        
        const inputs = form.querySelectorAll('input, textarea, select');
        
        inputs.forEach(input => {
            // Only validate fields inside our targeted containers
            const inputContainer = input.closest('.o-form-1__input');
            if (!inputContainer) return;
            
            // Attach event listeners for real-time validation
            input.addEventListener('blur', () => validateField(input, inputContainer));
            input.addEventListener('input', () => {
                // If they start typing and there's an error, re-validate immediately
                if (input.classList.contains('is-error')) {
                    validateField(input, inputContainer);
                }
            });
        });
        
        // Prevent submission if the form is invalid
        form.addEventListener('submit', function(e) {
            let isFormValid = true;
            
            inputs.forEach(input => {
                const inputContainer = input.closest('.o-form-1__input');
                if (inputContainer) {
                    const isFieldValid = validateField(input, inputContainer);
                    if (!isFieldValid) {
                        isFormValid = false;
                    }
                }
            });
            
            if (!isFormValid) {
                e.preventDefault(); // Stop form submission
                
                // Focus the first invalid input
                const firstInvalid = form.querySelector('.is-error');
                if (firstInvalid) firstInvalid.focus();
            }
        });
    });
    
    function validateField(input, container) {
        let isValid = input.checkValidity();
        let errorMessage = '';
        
        // Custom check for empty fields (sometimes checkValidity passes if 'required' is missing but we want to enforce it if it has an asterisk or specific logic, though HTML5 'required' is best)
        if (!isValid) {
            if (input.validity.valueMissing) {
                errorMessage = 'This field is required.';
            } else if (input.validity.typeMismatch && input.type === 'email') {
                errorMessage = 'Please enter a valid email address.';
            } else if (input.validity.tooShort) {
                errorMessage = `Minimum length is ${input.minLength} characters.`;
            } else {
                errorMessage = 'Please enter a valid value.';
            }
        }
        
        // Get or create the error message container
        let errorDiv = container.nextElementSibling;
        if (!errorDiv || !errorDiv.classList.contains('o-form-1__error')) {
            errorDiv = document.createElement('div');
            errorDiv.classList.add('o-form-1__error');
            // Basic styling for the error message
            errorDiv.style.color = '#d32f2f'; // Red color
            errorDiv.style.fontSize = '12px';
            errorDiv.style.marginTop = '4px';
            // Insert immediately after the .o-form-1__input container
            container.parentNode.insertBefore(errorDiv, container.nextSibling);
        }
        
        if (isValid) {
            // Remove error state
            input.classList.remove('is-error');
            errorDiv.style.display = 'none';
            errorDiv.textContent = '';
        } else {
            // Show error state
            input.classList.add('is-error');
            errorDiv.textContent = errorMessage;
            errorDiv.style.display = 'block';
        }
        
        return isValid;
    }
});
